import styled from 'styled-components';

import { BACKGROUND_BTN_HOVER, BACKGROUND_BTN, FONT_SIZE_BTN_TITLE, FONT_SIZE_BTN_TEXT, PADDING_CONTENT_PAGE, HEIGHT_BTN,LINE_HEIGHT_BTN, FONT_SIZE_BTN_ARROW, COLOR_BTN_HOVER } from '../../../globals';

export const StyledBtnOffice = styled.div`
  height: 100%;

  .btn-office-container {
    padding: ${PADDING_CONTENT_PAGE}px;
    height: 100%;
  }

  .btn-office-content {
    display: block;
    background-color: ${BACKGROUND_BTN};
    padding: 15px;
    cursor: pointer;
    box-shadow: 1px 1px 2px rgb(171, 169, 169);
    border-radius: 2px;
    color: inherit;
    text-decoration: none;
    height: 100%;
   }

  .btn-office-content:hover, .btn-office-content:visited, .btn-office-content:active {
    text-decoration: none;
  }

  .btn-office-table {
    width: 100%;
    table-layout: fixed;
    height: 100%;
  }

  td, div {
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .btn-office-content:hover {
    background-color: ${BACKGROUND_BTN_HOVER};
    color: ${COLOR_BTN_HOVER};
  }

  .btn-office-title {
    font-weight: bold;
    font-size: ${FONT_SIZE_BTN_TITLE}em;
  }

  .btn-office-address {
    font-size: ${FONT_SIZE_BTN_TEXT}em;
    line-height: ${LINE_HEIGHT_BTN};
    height: ${HEIGHT_BTN};
    word-break: normal;
  }

  .btn-office-arrow {
    width: 25px;
    text-align: center;
    vertical-align: middle;
    font-size: ${FONT_SIZE_BTN_ARROW}em;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`;



// WEBPACK FOOTER //
// ./src/common/BtnOffice/styles/StyledBtnOffice.js